import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import SchoolDashboardShell from '../components/SchoolDashboard.comp';
import {NAVY, PageHeader, BandChip, headCell, bodyCell} from '../components/widgets.comp';


const PRIORITY_COLOR = {High: '#E04535', Medium: '#EFA020', Low: '#6B7280'};

/* taller rows for this page */
const hCell = {...headCell, py: 2.75};
const bCell = {...bodyCell, py: 3.5, fontSize: '13.5px', lineHeight: 1.65};

const ROWS = [
    {priority: 'High',   where: 'Grade 8',      evidence: 'Lowest grade composite (59); Cyber Safety target weakest', action: 'Run a targeted follow-up and a year-group safeguarding session', owner: 'Head of Year 8'},
    {priority: 'High',   where: 'Whole school', evidence: 'Excessive Screen Time top risk (52% vs 42% national)',      action: 'Launch a screen-time / self-regulation campaign',                owner: 'SLT / pastoral lead'},
    {priority: 'Medium', where: 'Whole school', evidence: 'Screen-Time Self-Control lowest item (49)',                 action: 'Deploy a self-regulation & media-literacy area',                 owner: 'Computing lead'},
    {priority: 'Medium', where: 'Grade 9',      evidence: 'Participation 73% — below 75% threshold',                  action: 'Follow up with families to lift completion',                     owner: 'Head of Year 9'},
    {priority: 'Low',    where: 'Whole school', evidence: 'Trust in seeking help is low (context)',                    action: 'Make reporting routes visible and routine',                      owner: 'Safeguarding lead'},
];

const ActionPlanPage = () => (
    <SchoolDashboardShell skipNoDataGate>
        <PageHeader
            title="School Priority Action Plan"
            subtitle="What should school leaders and teachers do next?"
        />

        <TableContainer sx={{border: '1px solid var(--brand-border, #E5E7EB)', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)'}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{...hCell, width: '10%', textAlign: 'center'}}>Priority</TableCell>
                        <TableCell sx={{...hCell, width: '13%'}}>Where</TableCell>
                        <TableCell sx={{...hCell, width: '27%'}}>Evidence</TableCell>
                        <TableCell sx={{...hCell, width: '32%'}}>Recommended action</TableCell>
                        <TableCell sx={{...hCell, width: '18%'}}>Owner</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ROWS.map((r, i) => (
                        <TableRow key={i} sx={{backgroundColor: i % 2 === 0 ? '#fff' : 'var(--brand-surface-subtle, #F9FAFB)'}}>
                            <TableCell sx={{...bCell, textAlign: 'center'}}><BandChip label={r.priority} color={PRIORITY_COLOR[r.priority]}/></TableCell>
                            <TableCell sx={{...bCell, fontWeight: 700, color: NAVY}}>{r.where}</TableCell>
                            <TableCell sx={bCell}>{r.evidence}</TableCell>
                            <TableCell sx={bCell}>{r.action}</TableCell>
                            <TableCell sx={bCell}>{r.owner}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </SchoolDashboardShell>
);

export default ActionPlanPage;
